import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

import ComponentWrapper from '../ComponentWrapper/ComponentWrapper';

import './ImageUploaderComponent.scss';

/**
 * ImageUploaderComponent
 * @param {Object} block - The block
 * @param {Object} blockProps - The block props
 * @returns {React.ReactNode} - The image uploader
 */
const ImageUploaderComponent = ({ block, blockProps }) => {
  /**
   * Handle the removal of an image
   * @returns {void}
   */
  const onRemove = () => blockProps && blockProps.onRemove(block.getKey());
  const numberOfColumns = blockProps?.numberOfColumns || 1;

  /**
   * Handle the selection of an image
   * @returns {void}
   */
  const handleSelectImage = () => {
    blockProps.showImageSelectionModal(true, 'upload');
  };

  /**
   * Handle the creation of an image with AI
   * @returns {void}
   */
  const handleCreateWithAI = () => {
    blockProps.showImageSelectionModal(true, 'ai');
  };

  /**
   * Render the image uploader
   * @returns {React.ReactNode} - The image uploader
   */
  const imageUploader = () => {
    return (
      <div className="image-uploader">
        <div>Add Image</div>
        <div className="button-wrapper">
          <Button className="large-btn secondary-btn" onClick={handleSelectImage}>
            SELECT IMAGE
          </Button>
          <Button className="large-btn" onClick={handleCreateWithAI}>
            CREATE WITH AI
          </Button>
        </div>
      </div>
    );
  };

  return (
    <ComponentWrapper
      showDrag
      showActionButtons
      showEdit={false}
      showDelete
      isDraggable
      sectionName={blockProps.sectionName}
      remove={onRemove}
      blockKey={block.getKey()}
      setDraggingElement={blockProps.setDraggingElement}
      handleEditComponent={blockProps.handleEditComponent}
      setDropDisabled={blockProps.setDropDisabled}
      componentType={'ImageUploader'}>
      <div className="image-uploader-container">
        <div className={`image-uploader-wrapper image-uploader-cols-${numberOfColumns}`}>
          {imageUploader()}
        </div>
      </div>
    </ComponentWrapper>
  );
};

ImageUploaderComponent.propTypes = {
  block: PropTypes.object.isRequired,
  blockProps: PropTypes.object.isRequired,
};

export default ImageUploaderComponent;
